import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { EnumMultipleSingleMode, EnumButtonSizes } from '@/enums/enums';
import { usePagesUtilStore } from '@/stores/pagesUtilStore';
import { useInstitutionalStore } from '@/stores/institutionalStore'; // ✅


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnDeleteFocusedInstitutional',
  props: {
  propBtnSize: {
    type: String as () => keyof typeof EnumButtonSizes,
    required: true,
    default: EnumButtonSizes.SMALL
  },
  propInstitutionalId: { // ✅ recebe o id
    type: Number,
    required: false
  }
},
  setup(__props) {

const pagesUtilStore = usePagesUtilStore();
const institutionalStore = useInstitutionalStore(); // ✅

const props = __props;

const onDeleteFocusedInstitutionalBtnClick = () => {
  pagesUtilStore.modalDeleteInstitutionalConfirmationMode = EnumMultipleSingleMode.SINGLE;

  // ✅ salva o id no detail para o modal usar
  institutionalStore.institutionalDetail = { id: props.propInstitutionalId } as any

  pagesUtilStore.showModalDeleteInstitutionalConfirmation = true;
};

return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_openBlock(), _createBlock(_component_c_q_btn, {
    id: "btn-delete-focused-institutional",
    propBtnLabel: "Excluir",
    propBtnFunction: onDeleteFocusedInstitutionalBtnClick,
    propBtnTransparent: true,
    propBtnSize: props.propBtnSize
  }, null, 8, ["propBtnSize"]))
}
}

})